export const PageDataState = {
    Searchs: {
        official_course_code: {
            type: 'text',
            id: 'official_course_code',
            label: 'รหัสหลักสูตร',
            value: '',
            placeholder: 'รหัสหลักสูตร',
        },         
        course_eb_02_name: {
            type: 'text',
            id: 'course_eb_02_name',
            label: 'หลักสูตร',
            value: '',
            placeholder: 'หลักสูตร',
        },
        receiver: {
            type: 'text',
            id: 'receiver',
            label: 'ผู้รับเงิน',
            value: '',
            placeholder: 'ผู้รับเงิน',
        }, 
        tax_id: {
            type: 'text',
            id: 'tax_id',
            label: 'TAX ID',
            value: '',
            placeholder: 'เลขประจำตัวผู้เสียภาษี',
        },
        course_status: {
            type: 'select',
            id: 'course_status',
            label: 'การอบรม',
            value: '',
            placeholder: 'การอบรม',
        },         
    },
    Inputs: {
        id: {
            type: 'text',
            id: 'id',
            label: 'รหัส',
            value: '',
            validator: {
                type: 'text',
                required: false
            },
            error: { status: null, msg: '' }
        },
        course_eb_02_id: {
            type: 'select',
            id: 'course_eb_02_id',
            label: 'รหัสหลักสูตร',
            value: '',
            validator: {
                type: 'text',
                required: true
            },
            error: { status: null, msg: '' }
        },
        academy_detail: {
            type: 'text',
            id: 'academy_detail',
            label: 'หน่วยงานย่อย',
            value: '',
            validator: {
                type: 'text',
                required: false,
                minLength: 5,
                maxLength: 255
            },
            error: { status: null, msg: '' }
        }, 
        course_coordinator: {
            type: 'text',
            id: 'course_coordinator',
            label: 'ผู้ประสานงานหลักสูตร',
            value: '',
            validator: {
                type: 'text',
                required: true,
                minLength: 5,
                maxLength: 255
            },
            error: { status: null, msg: '' }
        }, 
        coordinator_department: {
            type: 'text',
            id: 'coordinator_department',
            label: 'หน่วยงาน',
            value: '',
            validator: {
                type: 'text',
                required: true,
                minLength: 5,
                maxLength: 255
            },
            error: { status: null, msg: '' }
        }, 
        coordinator_email: {
            type: 'text',
            id: 'coordinator_email',
            label: 'อีเมล',
            value: '',
            validator: {
                type: 'email',
                required: true
            },
            error: { status: null, msg: '' }
        },                  
        coordinator_contact: {
            type: 'text',
            id: 'coordinator_contact',
            label: 'โทรศัพท์มือถือ',
            value: '',
            validator: {
                type: 'text',
                required: true,
                minLength: 5,
                maxLength: 255                
            },
            error: { status: null, msg: '' }
        },
        trainee_amount: {
            type: 'text',
            id: 'trainee_amount',
            label: 'จำนวนผู้เข้ารับการอบรม',
            value: '',
            validator: {
                type: 'number',
                required: true,
                min: 1,
                max: 10000
            },
            error: { status: null, msg: '' }
        },
        trainee: {
            type: 'file',
            id: 'trainee',
            label: 'เอกสารแนบ รายชื่อ-ตำแหน่ง-บริษัท EB-04',
            fileId: '',  
            fileName: '', 
            fileInfo: {},
            value: '',
            validator: {
                type: 'file',
                required: true,
                accept: "application/pdf,application/msword"
            },
            error: { status: null, msg: '' }
        },
        lecturer_amount: {
            type: 'text',
            id: 'lecturer_amount',
            label: 'จำนวนวิทยากร',
            value: '',
            validator: {
                type: 'number',
                required: true,
                min: 1,
                max: 1000
            },
            error: { status: null, msg: '' }
        },
        lecturer: {
            type: 'file',
            id: 'lecturer',
            label: 'เอกสารแนบ รายชื่อ-ประวัติ CV',
            fileId: '',  
            fileName: '', 
            fileInfo: {},
            value: '',
            validator: {
                type: 'file',
                required: true,
                accept: "application/pdf,application/msword"
            },
            error: { status: null, msg: '' }
        },
        actual_expenses_total: {
            type: 'text',
            id: 'actual_expenses_total',
            label: 'ค่าใช้จ่ายตามจริง',
            value: '',
            validator: {
                type: 'number',
                required: true,
                min: 1,
                max: 1000000
            },
            error: { status: null, msg: '' }
        },
        registration_fee_employer_expenses: {
            type: 'text',
            id: 'registration_fee_employer_expenses',
            label: 'ค่าลงทะเบียน/ค่าใช้จ่ายที่ได้รับจากสถานประกอบการ',
            value: '',
            placeholder: 'ค่าลงทะเบียน/ค่าใช้จ่ายที่ได้รับ',
            validator: {
                type: 'number',
                required: true,
                min: 1,
                max: 1000000
            },
            error: { status: null, msg: '' }
        },
        eec_request_support_budget: {
            type: 'text',
            id: 'eec_request_support_budget',
            label: 'ขอรับเงินสนับสนุนจาก สกพอ.',
            value: '',
            validator: {
                type: 'number',
                required: true,
                min: 1,
                max: 1000000
            },
            error: { status: null, msg: '' }
        },
        eec_pay_support_budget: {
            type: 'text',
            id: 'eec_pay_support_budget',
            label: 'ขอรับเงินสนับสนุน',
            value: '',
            validator: {
                type: 'number',
                required: true,
                min: 1,
                max: 1000000
            },
            error: { status: null, msg: '' }
        },
        receiver: {
            type: 'text',
            id: 'receiver',
            label: 'ชื่อ/หน่วยงาน ผู้รับเงิน',
            value: '',
            validator: {
                type: 'text',
                required: true,
                minLength: 5,
                maxLength: 250
            },
            error: { status: null, msg: '' }
        },
        address: {
            type: 'textarea',
            rows: 3,
            id: 'address',
            label: 'ที่อยู่',
            value: '',
            validator: {
                type: 'text',
                required: true,
                minLength: 5,
                maxLength: 4096
            },
            error: { status: null, msg: '' }
        },
        tax_id: {
            type: 'text',
            id: 'tax_id',
            label: 'หมายเลขประจำตัวผู้เสียภาษี',
            value: '',
            validator: {
                type: 'text',
                required: true,
                minLength: 13,
                maxLength: 13
            },
            error: { status: null, msg: '' }
        },
        account_name: {
            type: 'text',
            id: 'account_name',
            label: 'ชื่อบัญชี',
            value: '',
            validator: {
                type: 'text',
                required: true,
                minLength: 5,
                maxLength: 250
            },
            error: { status: null, msg: '' }
        },
        account_number: {
            type: 'text',
            id: 'account_number',
            label: 'หมายเลขบัญชี',
            value: '',
            validator: {
                type: 'text',
                required: true,
                minLength: 10,
                maxLength: 250
            },
            error: { status: null, msg: '' }
        },
        bank: {
            type: 'text',
            id: 'bank',
            label: 'ธนาคาร',
            value: '',
            validator: {
                type: 'text',
                required: true,
                minLength: 5,
                maxLength: 250
            },
            error: { status: null, msg: '' }
        },
        branch: {
            type: 'text',
            id: 'branch',
            label: 'สาขา',
            value: '',
            validator: {
                type: 'text',
                required: true,
                minLength: 5,
                maxLength: 250
            },
            error: { status: null, msg: '' }
        },
        report_eec_hdc_doc: {
            type: 'file',
            id: 'report_eec_hdc_doc',
            label: '4.1 หน้ารายงานต่อประธาน EEC HDC (ตาม template)',
            fileId: '',  
            fileName: '', 
            fileInfo: {},
            value: '',
            validator: {
                type: 'file',
                required: true,
                accept: "application/pdf,application/msword"
            },
            error: { status: null, msg: '' }
        },
        eb_02_doc: {
            type: 'file',
            id: 'eb_02_doc',
            label: '4.2 สำเนาเอกสารอนุมัติจัดอบรมจาก EEC HDC / สกพอ. (EB-02)',
            fileId: '',  
            fileName: '', 
            fileInfo: {},
            value: '',
            validator: {
                type: 'file',
                required: true,
                accept: "application/pdf,application/msword"
            },
            error: { status: null, msg: '' }
        },
        training_result_doc: {
            type: 'file',
            id: 'training_result_doc',
            label: '4.3 รายงานผลสัมฤทธิ์การอบรมและผลสอบ pre/post test',
            fileId: '',  
            fileName: '', 
            fileInfo: {},
            value: '',
            validator: {
                type: 'file',
                required: true,
                accept: "application/pdf,application/msword"
            },
            error: { status: null, msg: '' }
        },
        income_expense_doc: {
            type: 'file',
            id: 'income_expense_doc',
            label: '4.4 รายงานบัญชีรับ - จ่าย เพื่อแสดงรายละเอียดการเบิกจ่ายเงิน (สามารถใช้แบบฟอร์มของหน่วยงานจัดอบรมได้)', // 
            fileId: '',  
            fileName: '', 
            fileInfo: {},
            value: '',
            validator: {
                type: 'file',
                required: true,
                accept: "application/pdf,application/msword"
            },
            error: { status: null, msg: '' }
        },
        payslip_doc: {
            type: 'file',
            id: 'payslip_doc',
            label: '4.5 หลักฐานการชำระเงินจากสถานประกอบการที่เข้ารับการอบรม',
            fileId: '',  
            fileName: '', 
            fileInfo: {},
            value: '',
            validator: {
                type: 'file',
                required: true,
                accept: "application/pdf,application/msword"
            },
            error: { status: null, msg: '' }
        },
        eb_04_doc: {
            type: 'file',
            id: 'eb_04_doc',
            label: '4.6 เอกสารรับรองจากสถานประกอบการที่เข้ารับการอบรม (EB-04)',
            fileId: '',  
            fileName: '', 
            fileInfo: {},
            value: '',
            validator: {
                type: 'file',
                required: true,
                accept: "application/pdf,application/msword"
            },
            error: { status: null, msg: '' }
        },
        photo_doc: {
            type: 'file',
            id: 'photo_doc',
            label: '4.7 รูปถ่ายบรรยากาศการฝึกอบรมจำนวนไม่ต่ำกว่า 4 รูป',
            fileId: '',  
            fileName: '', 
            fileInfo: {},
            value: '',
            validator: {
                type: 'file',
                required: true,
                accept: "application/pdf,application/msword"
            },
            error: { status: null, msg: '' }
        },
        lecturer_profile_doc: {
            type: 'file',
            id: 'lecturer_profile_doc',
            label: '4.8 ประวัติวิทยากร',
            fileId: '',  
            fileName: '', 
            fileInfo: {},
            value: '',
            validator: {
                type: 'file',
                required: true,
                accept: "application/pdf,application/msword"
            },
            error: { status: null, msg: '' }
        },
        fullname: {
            type: 'text',
            id: 'fullname',
            label: 'ผู้รายงาน',
            value: '',
            validator: {
                type: 'text',
                required: true,
                minLength: 5,
                maxLength: 250
            },
            error: { status: null, msg: '' }
        },
        position: {
            type: 'text',
            id: 'position',
            label: 'ตำแหน่ง',
            value: '',
            validator: {
                type: 'text',
                required: true,
                minLength: 5,
                maxLength: 250
            },
            error: { status: null, msg: '' }
        },
        form_date: {
            type: 'text',
            id: 'form_date',
            label: 'วันที่',
            value: '',
            validator: {
                type: 'date',
                required: true
            },
            error: { status: null, msg: '' }
        },
    },
    ReadOnlys: {
        budget_code: {
            id: 'budget_code',
            label: 'รหัสกันเงินงบประมาณ'
        },
        course_eb_02_name: {
            id: 'course_eb_02_name',
            label: 'ชื่อหลักสูตร'
        },  
        academy_name: {
            id: 'academy_name',
            label: 'สถานศึกษาผู้รับผิดชอบหลักสูตร'
        }, 
        academy_province_name: {
            id: 'academy_province_name',
            label: 'จังหวัด'
        },   
        registration_fee_employer_expenses_percent: {
            id: 'registration_fee_employer_expenses_percent',
            label: 'ร้อยละ'
        },
        eec_request_support_budget_percent: {
            id: 'eec_request_support_budget_percent',
            label: 'ร้อยละ'
        },
        eec_pay_support_budget_text: {
            id: 'eec_pay_support_budget_text',
            label: 'ขอรับเงินสนับสนุน (เป็นตัวอักษร)'            
        }                                     
    },    
    InputGroup: {}
}        

